import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  Image,
  Stepper,
  TranslationProvider,
  getTranslation,
} from '@resy/ui-kitchen';

import './AddOn.scss';

class AddOn extends React.Component {
  static propTypes = {
    categoryId: PropTypes.number,
    description: PropTypes.string,
    fulfilled: PropTypes.bool,
    id: PropTypes.number.isRequired,
    image: PropTypes.string,
    inventory: PropTypes.shape({
      date: PropTypes.string,
      quantity: PropTypes.number,
    }),
    max: PropTypes.number,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    price: PropTypes.string.isRequired,
    quantity: PropTypes.number,
  }

  static defaultProps = {
    categoryId: undefined,
    description: '',
    fulfilled: undefined,
    image: '',
    max: undefined,
    inventory: undefined,
    onChange: () => {},
    quantity: undefined,
  }

  decrement = () => {
    const {
      categoryId,
      id,
      onChange,
      quantity,
    } = this.props;

    if (quantity > 0) {
      // AddOnPage, onAddItem
      onChange(id, categoryId, quantity - 1);
    }
  }

  increment = () => {
    const {
      categoryId,
      id,
      onChange,
      quantity,
    } = this.props;

    // AddOnPage, onAddItem
    onChange(id, categoryId, quantity + 1);
  }

  isAtLimitIventory = () => {
    const {
      inventory: {
        quantity: inventory,
      } = {},
      quantity,
    } = this.props;

    if (!inventory) {
      return false;
    }
    return (quantity >= inventory);
  }

  isAtLimit = () => {
    const {
      inventory: {
        quantity: inventory,
      } = {},
      max,
      quantity,
    } = this.props;

    if (inventory === 0) {
      return true;
    }

    if (typeof inventory !== 'number' && typeof max !== 'number') {
      return false;
    }

    if (typeof max === 'number') {
      return (quantity >= this.maxUpToInventory(max, inventory));
    }

    return (quantity >= inventory);
  }

  isError = () => {
    const {
      inventory: {
        quantity: inventory,
      },
      quantity,
    } = this.props;

    if (typeof inventory !== 'number') {
      return false;
    }

    return quantity > inventory;
  }

  maxUpToInventory = (max, inventory) => {
    if (typeof max === 'number' && !(typeof inventory === 'number')) {
      return max;
    }
    if (
      typeof inventory === 'number'
      && typeof max === 'number'
    ) {
      return (max > inventory) ? inventory : max;
    }
    return max;
  }

  onChange = (e) => {
    const {
      inventory: {
        quantity: inventory,
      },
      max,
    } = this.props;

    // if the max is 10, but only 5 in inventory, the max is inventory
    const maxUpToInventory = this.maxUpToInventory(max, inventory);

    const val = Stepper.MinMax(
      +e.currentTarget.value,
      0,
      typeof maxUpToInventory === 'number' ? maxUpToInventory : inventory
    );
    const {
      categoryId,
      id,
      onChange,
    } = this.props;

    if (onChange) {
      // AddOnPage, onAddItem
      onChange(id, categoryId, val);
    }
  }

  renderAtLimit = () => {
    const {
      inventory: {
        quantity: inventory,
      } = {},
    } = this.props;

    return (
      <div className="AddOnItem__limit" role="alert" aria-live="assertive">
        <TranslationProvider translationKey="in_stock" translationValue={{ inventory }}>
          <span>{`Only ${inventory} in stock.`}</span>
        </TranslationProvider>
      </div>
    );
  }

  renderImage = () => {
    const { image, name } = this.props;

    if (!image) {
      return null;
    }

    return (
      <Image className="AddOnItem__image" alt={name} src={image} />
    );
  }

  render() {
    const {
      description,
      fulfilled,
      inventory: {
        quantity: inventory,
      } = {},
      max,
      name,
      price,
      quantity,
    } = this.props;

    const soldOut = inventory === 0 || inventory === undefined;
    const isFree = !/[1-9]/.test(price);

    const quantityTranslation = getTranslation({
      translationKey: 'quantity',
      fallback: 'quantity',
    });

    return (
      <div className={cx('AddOnItem', {
        active: quantity > 0,
        error: this.isError(),
        'sold-out': soldOut,
        fulfilled: fulfilled && !quantity,
      })}
      >
        <div className="AddOnItem__details-container">
          <div className="AddOnItem__details-container-text">
            <div className="AddOnItem__name">{name}</div>
            <div className="AddOnItem__description">{description}</div>
            {this.isAtLimitIventory() && this.renderAtLimit(quantity)}
          </div>
          {this.renderImage()}
        </div>
        <div className="AddOnItem__price-container">
          {soldOut
            && (
              <TranslationProvider translationKey="sold_out">
                <div className="AddOnItem__price">Sold Out</div>
              </TranslationProvider>
            )}
          {(isFree || soldOut) ? <div /> : <div className="AddOnItem__price">{price}</div>}
          {!soldOut
            && (
            <Stepper
              disabledDecrement={quantity <= 0}
              disabledIncrement={fulfilled || this.isAtLimit()}
              incrementLabel={`Increment ${name}`}
              decrementLabel={`Decrement ${name}`}
              fulfilled={fulfilled}
              onChange={this.onChange}
              onDecrement={this.decrement}
              onIncrement={this.increment}
              max={max}
              value={quantity || 0}
              groupLabel={`${name} ${quantityTranslation}`}
            />
            )}
        </div>
      </div>
    );
  }
}

AddOn.displayName = 'AddOn';
export default AddOn;
